/**
 * Created with IntelliJ IDEA.
 * User: omerh
 * Date: 6/3/13
 * Time: 10:37 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var CONST = require("const");
    var Button = require("ui/button/Button");
    var Logger = require('logger');
    var _ = require("underscore");
    var $ = require("jquery");
    var ESCAPE_KEY_CODE = 27;
    var TAB_KEY_CODE = 9;
    var SPACE_KEY_CODE = 32;
    var ENTER_KEY_CODE = 13;

    var NotifierView = Marionette.ItemView.extend({
        tagName:"div",
        ui:{
            cancelBtn:".cancelBtn",
            middleBtn:".middleBtn",
            actionBtn:".actionBtn",
            content:".notifierContent",
            notifierBox: ".notifierBoxContainer"
        },
        events:{
            "click .closeNotifier":"_cancelAction",
            "keydown .closeNotifier": "_closeBtnAction",
            "keydown .notifier-container":"_keydownAction"
        },
        initialize:function (options) {
            this.logger = Logger.getLogger('Notifier');
            this.model = options.model;
            this.container = options.container;
            this.callback = options.callback || null;
            this.middleCallback   = options.middleCallback || null;
            this.cancelCallback = options.cancelCallback || null;
            this.vent = options.vent;
            this.timeToShow = options.timeToShow;
            this.instanceId = options.instanceId;
            this.contentView = options.contentView || null;
            this.pageToIgnoreDomEvents = options.pageToIgnoreDomEvents;
        },
        onRender:function () {
            // if removePrimaryButton was set to true and the cancelBtn exist, remove it
            if (this.model.get("removePrimaryButton") && this.$(".actionBtn")) {
                this.$(".actionBtn").remove();
            }
            // if removeMiddleButton was set to true and the middleBtn exist, remove it
            if (this.model.get("removeMiddleButton") && this.$(".middleBtn")) {
                this.$(".middleBtn").remove();
            }
            // if removeAditionalButton was set to true and the cancelBtn exist, remove it
            if (this.model.get("removeAditionalButton") && this.$(".cancelBtn")) {
                this.$(".cancelBtn").remove();
            }

            if (this.contentView) { // we will display a sub view in the content container
                this.contentView.render();
                this.contentView.delegateEvents();
                this.ui.content.empty().append(this.contentView.$el);
            }

            this.ui.content.addClass(this.model.get("contentMessageClass"));

            if (this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.INFO) {
                this.ui.content.addClass("info");
                this.displayNotification();
            } else if (this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.WARNING){
                this.ui.content.addClass("warning");
                this.displayNotification();
            } else if (this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.SUCCESS || this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.ERROR || this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.ERROR_MINI) {
                this.displayNotification();
            } else if (this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.ERROR_BLOCKING || this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.ERROR_GLOBAL ||
                this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.CONFIRM || this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.CONFIRM_GLOBAL) {
                this.displayNotificationWithOverlay();
            } else if (this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.WARNING_NO_CLOSE){
                this.ui.content.addClass("warning");
                this.displayNotification();
            }
            var el = this.$el.find(":first");
            this.vent.trigger(this.model.get("module") + ":notifier:onNotificationRender", {'module':this.model.get("module"), id: this.instanceId, top: parseInt(el.css("top"),10), height: el.height()});
        },
        onClose: function () {
            if (this.contentView) {
                this.contentView.close();
            }
        },
        closeNotifier:function () {
            var that = this;
            if (this.container) {
                var rootEls = $(this.container).children();
                var filteredEls = Array.prototype.slice.call(rootEls).filter(function(el) { return el !== that.el; });
                this.setAriaHidden(filteredEls, 'false');
                $(this.container).unbind("keydown", this._keydownAction);
            }

            that.close();
            that.vent.trigger(that.model.get("module") + ":notifier:onNotificationClosed", {'module':that.model.get("module"), id: that.instanceId});
            setTimeout(function() {
                if (that.pageToIgnoreDomEvents) {
                    that.pageToIgnoreDomEvents.setIgnoreDomEvents(false);
                }
            }, 100);
        },
        invokeAction:function () {
            if (this.callback) {
                try {
                    var ret = this.callback();
                    if (false !== ret) {
                        this.closeNotifier();
                    }
                }
                catch (e) {
                    this.logger.error("onClick callback threw an error - type: " + e.name + " msg: " + e.message);
                    this.logger.graph({ name: "UIComponents:Notifier:invokeActionError"});
                    this.closeNotifier();
                }
            }
        },
        invokeMiddleAction:function () {
            if (this.middleCallback) {
                try {
                    var ret = this.middleCallback();
                    if (false !== ret) {
                        this.closeNotifier();
                    }
                }
                catch (e) {
                    this.logger.error("onClick middleCallback threw an error - type: " + e.name + " msg: " + e.message);
                    this.logger.graph({ name: "UIComponents:Notifier:invokeActionError"});
                    this.closeNotifier();
                }
            }
        },
        setAriaHidden: function(els, status) {
            // this must first be converted to an array using Array.from() or Array.prototype.slice.call() to be able to grab the elements that require the attribute
            Array.prototype.slice.call(els).forEach(function(el) {
                el.setAttribute('aria-hidden', status);
            });
        },
        _cancelAction:function () {
            this.closeNotifier();
            if (this.cancelCallback){
                this.cancelCallback();
            }
        },
        _closeBtnAction: function (e) {
            if(e.keyCode === SPACE_KEY_CODE || e.keyCode === ENTER_KEY_CODE) {
                this._cancelAction();
            }
        },
        _keydownAction: function (e) {
            var firstFocusableEl;
            var lastFocusableEl;
            var focusableEls;
            
            var $container = $(".notifierBoxContainer, .notifier-container");
            focusableEls = $container.find(":tabbable");
            
            if (focusableEls && focusableEls.length) {
                firstFocusableEl = focusableEls[0];
                lastFocusableEl = focusableEls[focusableEls.length - 1];

                if (ESCAPE_KEY_CODE === e.keyCode) {
                    e.stopPropagation();
                    e.preventDefault();
                    this._cancelAction();
                } else if (e.key === 'Tab' || e.keyCode === TAB_KEY_CODE) {
                    if ( e.shiftKey ) /* shift + tab */ {
                        if (e.target === firstFocusableEl) {
                            e.preventDefault();
                            lastFocusableEl.focus();
                        }
                    } else /* tab */ {        
                        if (e.target === lastFocusableEl) {
                            e.preventDefault();
                            firstFocusableEl.focus();
                        }
                    }
                }
            }
        },
        displayNotification:function () {
            var that = this;
            var top = this.model.get("topPosition");

            if (this.model.get("type") === CONST.SYSTEM_NOTIFICATIONS.ERROR_MINI) {
                if (this.model.get("textAction")) {
                    this.actionBtn = new Button({
                        el:this.ui.actionBtn,
                        tooltip: "", // show no tooltip on notification dialog buttons
                        permutation:Button.PERMUTATION.LIGHT_BLUELINK,
                        initState:Button.STATES.ENABLED,
                        onClick:_.bind(this.invokeAction, this)
                    });
                    this.actionBtn.render();
                }
            }

            //Decide if clicking the banner will close it
            if (!that.options.disableClickToClose) {
                this.$el.on("click", function () {
                    that.closeNotifier();
                });
            }

            var notifierContainer = this.$el.children(".notifier-container");
            notifierContainer.css("display", "none");
            this.$el.find(":first").css("top", top);

            $(this.container).append(this.el);
            setTimeout(function () {
                notifierContainer.fadeIn(1000, "swing", function () {
                    if (that.pageToIgnoreDomEvents) {
                        that.pageToIgnoreDomEvents.setIgnoreDomEvents(true);
                    }
                    //Decide if the banner should automatically fade out or remain persistent
                    if (!that.options.persist) {
                        setTimeout(function () {
                            if (that.pageToIgnoreDomEvents) {
                                that.pageToIgnoreDomEvents.setIgnoreDomEvents(false);
                            }
                            notifierContainer.fadeOut(3000, function () {
                                that.closeNotifier();
                            });
                        }, that.timeToShow);
                    }

                    notifierContainer.focus();
                });
            }, 1);
        },
        displayNotificationWithOverlay:function () {
            var that = this;

            this.cancelBtn = new Button({
                el:this.ui.cancelBtn,
                tooltip: "", // show no tooltip on notification dialog buttons
                permutation:Button.PERMUTATION.LINK_NIGHT,
                initState:Button.STATES.ENABLED,
                onClick:_.bind(this._cancelAction, this)
            });
            this.cancelBtn.render();

            this.middleBtn = new Button({
                el:this.ui.middleBtn,
                tooltip: "", // show no tooltip on notification dialog buttons
                permutation:Button.PERMUTATION.BTN_DARK,
                initState:Button.STATES.ENABLED,
                onClick:_.bind(this.invokeMiddleAction, this)
            });
            this.middleBtn.render();

            this.actionBtn = new Button({
                el:this.ui.actionBtn,
                tooltip: "", // show no tooltip on notification dialog buttons
                permutation: this.model.removeMiddleButton ? Button.PERMUTATION.BTN_DARK: Button.PERMUTATION.BTN_PRIMARY,  //if we have middle button the action button should be primary
                initState:Button.STATES.ENABLED,
                onClick:_.bind(this.invokeAction, this)
            });
            this.actionBtn.render();

            $(this.container).append(this.el);
            $(this.container).bind("keydown", this._keydownAction);

            var rootEls = $(this.container).children();
            var filteredEls = Array.prototype.slice.call(rootEls).filter(function(el) { return el !== that.el; });

            // set timeout before setting aria-hidden attribute
            // because tooltip-container appears just after modal pops up
            setTimeout(function() {
                that.setAriaHidden(filteredEls, 'true');
            }, 500);



            // in order to keep the box centralized, we need to set margins to be half of the width and height.
            var height = this.ui.notifierBox.outerHeight();
            var width = this.ui.notifierBox.outerWidth();
            var marginTop = (height / 2) * -1;
            var marginLeft = (width / 2) * -1;
            this.ui.notifierBox.css({marginTop:marginTop, marginLeft:marginLeft});

            this.ui.notifierBox.focus();
        }
    });
    return NotifierView;
});
